import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import ClassEditor from 'components/Store/ClassEditor'
import DropdownButton from 'react-bootstrap/DropdownButton'
import Dropdown from 'react-bootstrap/Dropdown'
import { useDispatch, useSelector } from 'react-redux'
import { useForm, Controller } from "react-hook-form";
import { DevTool } from "react-hook-form-devtools";
import * as yup from 'yup';
import FormGroup from 'components/Form/FormGroup'
import Button from 'react-bootstrap/Button'
import { saveOffering } from 'store/actions/offeringsActions'
import SweetAlert from 'react-bootstrap-sweetalert'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton'
import EditIcon from '@material-ui/icons/Edit';
import { deleteOffering } from 'store/actions/offeringsActions'
import analytics from 'util/analytics';
import Spinner from 'react-bootstrap/Spinner'
import FormImageUploader from 'components/Form/FormImageUploader'
import { symbolFromCurrency } from 'components/PartnerInfoForm'
import { processServices } from 'components/forms/NewFormButton'

export const frequencyOptions = [
    { label: "Weekly", value: "weekly" },
    { label: "Monthly", value: "monthly" },
    { label: "Every 3 months", value: "quarterly" },
    { label: "Every 6 months", value: "semiannually" },
    { label: "Yearly", value: "yearly" }
]

export const frequencyFromExpiresIn = (expiresIn) => {
    switch (expiresIn) {
        case 7:
            return "weekly"
        case 30:
            return "monthly"
        case 90:
            return "quarterly"
        case 180:
            return "semiannually"
        case 365:
            return "yearly"
        default:
            return "infinity"
    }
}

export const expiresInFromFrequency = (frequency) => {
    switch (frequency) {
        case "weekly":
            return 7
        case "monthly":
            return 30
        case "quarterly":
            return 90
        case "semiannually":
            return 180
        case "yearly":
            return 365
        default:
            return 99999
    }
}

const packageTemplate = {
    id: "123456", // string: uniqueId
    partnerId: "", // string: instructor that's selling this
    type: "subscription", // string[ENUM]: package,subscription,other (choosing not to use boolean to leave room for other types in the future)
    name: "", // string
    description: "", // string
    price: 10, // double: dollars
    count: 99999, // number: to burn (very large number for subscriptions)
    expiresIn: 99999 // number: days
}

const purchaseItemTemplate = {
    offering: {
        id: "123456", // string: uniqueId
        partnerId: "", // string: instructor that's selling this
        type: "subscription", // string[ENUM]: package,subscription,other (choosing not to use boolean to leave room for other types in the future)
        name: "", // string
        description: "", // string
        price: 10, // double: dollars
        count: 99999, // number: to burn (very large number for subscriptions)
        expiresIn: 99999 // number: days
    },
    userId: "", // string: student that bought this
    remaining: 99999, // number: starts at count and burns until 0
    expires: 1592613259, // timestamp
    created: 1592613259, // timestamp
    purchased: false // default set to false. once we get a success from stripe then we'll set this to true
}

export const locationTypeOptions = [
    {
        label: "All In-Person Classes",
        value: "inperson"
    },
    {
        label: "All Livestream Classes",
        value: "live"
    },
    {
        label: "All On Demand Videos",
        value: "ondemand"
    },
    {
        label: "All Private Sessions",
        value: "private"
    }
]

const offeringTypeOptions = [
    {
        label: "Subscription",
        value: "subscription"
    },
    {
        label: "Class Package",
        value: "pack"
    }
]

const newStudentOnlyOptions = [
    {
        label: "New students only",
        value: true
    },
    {
        label: "New & existing students",
        value: false
    }
]

const discountTypeOptions = [
    {
        label: "None",
        value: "none"
    },
    {
        label: "First period discount",
        value: "firstPeriodDiscount"
    },
    {
        label: "Free Trial",
        value: "freeTrial"
    },

]

const subscriptionTypeOptions = [
    {
        label: "Unlimited",
        value: "unlimited"
    },
    {
        label: "Recurring Package",
        value: "limited"
    }
]

function PackageEditor(props) {

    const challenges = useSelector(state => state.instructor.offerings.filter(val => val.type === "challenge"))
    const challengeOptions = challenges.map(val => {
        return {
            label: val.name,
            value: val.id
        }
    })

    const serviceOptions = useSelector(state => processServices(state.scheduling.services))
    const categories = useSelector(state => state.instructor.categories);
    const categoryOptions = categories.map(val => {
        return {
            label: val,
            value: encodeURIComponent(val)
        }
    })
    // console.log('Offerings')
    // console.log(offerings)
    // console.trace()
    // useEffect(() => {
    //     if (offerings) {
    //         console.trace()
    //     }
    // }, [offerings])

    const dispatch = useDispatch()
    const partnerId = useSelector(state => state.instructor.instructor.platformID)
    const currency = useSelector(state => state.instructor.instructor.instructorProfile?.currency ?? "USD");
    const currencySymbol = symbolFromCurrency(currency)
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });



    const { toEdit } = props
    let { pack, subscription, challenge, oneTimeOffer } = props
    let offeringType = null

    let defaultDescription = ""
    let defaultDescriptionHTML = ""
    if (pack) {
        defaultDescription = `
            Redeemable for:
                * Yoga Flow LIVE classes
                * Any on-demand video
        `
        defaultDescriptionHTML = `
            <p>Redeemable for:</p> 
            <ul> 
                <li>Yoga Flow LIVE classes</li> 
                <li>Any on-demand video</li> 
            </ul>
        `

    } else if (subscription) {
        defaultDescription = `
            * Access to all of my live classes 
            * Recordings after each class 
            * Access to full on-demand video library
        `
        defaultDescriptionHTML = `
            <ul>
                <li>Access to all of my live classes</li>
                <li>Recordings after each class</li>
                <li>Access to full on-demand video library</li>
            </ul>
        `
    } else if (challenge) {

    }

    if (toEdit?.type) {
        // console.log("to edit")
        // console.log(toEdit)
        switch (toEdit.type) {
            case "pack":
                pack = true
                subscription = false
                challenge = false
                oneTimeOffer = false
                break
            case "subscription":
                pack = false
                subscription = true
                challenge = false
                oneTimeOffer = false
                break
            case "challenge":
                pack = false
                subscription = false
                challenge = true
                oneTimeOffer = false
                break
            default:
                break
        }
        if (toEdit?.isOneTimeOffer) {
            oneTimeOffer = true
        }
    }

    var viewModel = {
        placeholders: {
            name: "",
            price: "",
            description: ""
        }
    }

    if (pack) {
        viewModel.placeholders.name = "5 Class Pack"
        viewModel.placeholders.price = "30"
        viewModel.placeholders.description = "Optional. This is great if your package name does not describe everything that is included in the package."
        offeringType = "pack"
    } else if (subscription) {
        viewModel.placeholders.name = "Weekly Subscription, Premium Plan"
        viewModel.placeholders.price = "100"
        viewModel.placeholders.description = "Optional. This is great if your subscription name does not describe everything that is included in the package."
        offeringType = "subscription"
    } else if (challenge) {
        viewModel.placeholders.name = "30-day workout challenge"
        viewModel.placeholders.price = "100"
        viewModel.placeholders.description = "Tell your students what's included"
        offeringType = "challenge"
    } else if (oneTimeOffer) {

    }

    // const defualtToEdit = {...toEdit}
    const { register, control, handleSubmit, setValue, formState, errors, dirty, getValues, watch } = useForm({
        mode: 'onBlur',
        validationSchema: yup.object({
            name: yup.string().required('Please enter a name'),
            description: yup.string(),
            price: yup.number("Please enter a valid price greater than zero").required('Please enter a price').typeError('Please enter a valid price greater than zero'),
            subscriptionType: yup.string().when("type", {
                is: "subscription",
                then: yup.string("Pick a type").required("Please choose a type")
            }),
            subscriptionCount: yup.number().when("subscriptionType", {
                is: "limited",
                then: yup.number("Please enter a valid number grater than zero").positive('Please enter a valid number grater than zero').required('Please enter a quantity').typeError('Please enter a valid number greater than zero')
            }).typeError('Please enter a valid number greater than zero'),
            count: yup.number().when("type", {
                is: "pack",
                then: yup.number("Please enter a valid number grater than zero").positive('Please enter a valid number grater than zero').required('Please enter a quantity').typeError('Please enter a valid number greater than zero')
            }).typeError('Please enter a valid number greater than zero'),
            frequency: yup.string().when("type", {
                is: "subscription",
                then: yup.string("Please enter a valid friequency").required("Please select a billing frequency").typeError('Please enter a billing frequency')
            }),

            locationTypes: yup.array(),
            applies_to_services: yup.array(),
            applies_to_categories: yup.array(),

            firstPeriodPrice: yup.number("Please enter a valid number grater than zero").when("discountType", {
                is: 'firstPeriodDiscount',
                then: yup.number("Please enter a valid number grater than zero").positive('Please enter a valid number grater than zero').required("Please input a price for the first billing cycle")
            }),
            freeTrialPeriodDays: yup.number("Please enter a valid number grater than zero").when("discountType", {
                is: 'freeTrial',
                then: yup.number("Please enter a valid number grater than zero").positive('Please enter a valid number grater than zero').required("Please input the number of days for a free trial")
            }),
            expiresIn: yup.number().when("expires", {
                is: true,
                then: yup.number("Please enter a valid number grater than zero").positive('Please enter a valid number grater than zero').required("Please input the number of days for a free trial")
            }),
            // firstPeriodPrice: yup.number("Please enter a valid price greater than zero").positive('Please enter a valid number grater than zero').typeError('Please enter a valid price greater than zero'),
            // firstPeriodPrice: yup.object().shape({
            //     decimal: yup.number().test(
            //         'is-decimal',
            //         'invalid decimal',
            //         value => (value + "").match(/^\d+(?:\.\d{0,2})$/)
            //     ),
            // }).required('Please enter a price').typeError('Please enter a valid price greater than zero')
        }),
        defaultValues: {
            id: toEdit?.id,
            type: offeringType,
            name: toEdit?.name ?? "",
            description: toEdit?.description ?? defaultDescription,
            descriptionHTML: toEdit?.descriptionHTML ?? defaultDescriptionHTML,
            imageUrl: toEdit?.images ? toEdit.images[0] : null,
            price: toEdit?.price,
            subscriptionCount: toEdit?.subscriptionType === 'limited' ? toEdit?.count : 999999,
            subscriptionType: toEdit?.subscriptionType ?? (subscription ? "unlimited" : "none"),
            count: toEdit?.count,
            frequency: toEdit?.expiresIn ? frequencyFromExpiresIn(toEdit.expiresIn) : null,
            expires: toEdit?.expires ? true : (subscription ? true : false),
            expiresIn: toEdit?.expiresIn || 99999,

            locationTypes: toEdit?.locationTypes ?? ['live'],
            applies_to_services: toEdit?.applies_to_services ?? [],
            applies_to_categories: toEdit?.applies_to_categories ?? [],

            private: toEdit ? (toEdit.active === true ? false : true) : false,
            isOneTimeOffer: oneTimeOffer ? true : false,
            newStudentOnly: toEdit?.newStudentOnly ? true : false,
            discountType: toEdit?.discountType ?? 'none',
            firstPeriodPrice: toEdit?.firstPeriodPrice,
            freeTrialPeriodDays: toEdit?.freeTrialPeriodDays ?? 0,
            challenges: toEdit?.challenges ?? []
        }
    });

    const [showAdvanced, setShowAdvanced] = useState(toEdit?.applies_to_services?.length > 0 ||
        toEdit?.applies_to_categories?.length > 0 ||
        toEdit?.categories?.length > 0)
    useEffect(() => {
        register({ name: 'id' })
        register({ name: 'isOneTimeOffer' })
        register({ name: 'type' })
        // register({ name: 'expiresIn'})
        register({ name: 'imageUrl' })
        // register({ name: 'active'})
        // How do you find instructors and how do you vet them?
    }, [register])

    const [isSaving, setIsSaving] = React.useState(false)
    const [saveError, setSaveError] = React.useState(null)

    console.log("Errors: ", errors)
    const htmlPlainText = (html) => {

        console.log("html", html)
        html = html.replace(/<style([\s\S]*?)<\/style>/gi, '');
        html = html.replace(/<script([\s\S]*?)<\/script>/gi, '');
        html = html.replace(/<\/div>/ig, '\n');
        html = html.replace(/<\/li>/ig, '\n');
        html = html.replace(/<li>/ig, '  *  ');
        html = html.replace(/<\/ul>/ig, '\n');
        html = html.replace(/<\/p>/ig, '\n');
        html = html.replace(/<br\s*[\/]?>/gi, "\n");
        html = html.replace(/<[^>]+>/ig, '');

        return html
    }


    const onSubmit = (data) => {

        if (
            (!data.locationTypes || data.locationTypes?.length === 0) &&
        (!data.applies_to_services || data.applies_to_services?.length === 0) &&
        (!data.applies_to_categories || data.applies_to_categories?.length == 0) &&
        (!data.challenges || data.challenges?.length === 0)
        ) {
            window.alert("Oops! Please select an offering type you'd like to applythis pricing option to")
            return
        }

    if (data.description) {
        let description_copy = (' ' + data.description).slice(1);
        data.descriptionHTML = description_copy
        data.description = htmlPlainText(data.description)
    }

    if (data.imageUrl) {
        data.images = [data.imageUrl]
    }
    delete data.imageUrl

    data.active = !data.private
    delete data.private

    if (data.type === 'subscription') {
        if (data.subscriptionType === 'limited') {
            data.count = data.subscriptionCount
        } else if (data.subscriptionType === 'unlimited') { // 
            data.count = 999999
        } else {
            window.alert("something went wrong saving this offering")
            return
        }


        if (data.frequency) {
            data.expiresIn = expiresInFromFrequency(data.frequency)

        } else {
            window.alert("Must choose frequency")
            return
        }
    } else if (data.type === 'pack') {
        // expiresIn = data.expiresIn
        data.subscriptionType = 'none'

        if (!data.expires) {
            data.expiresIn = 999999
        }

    } else if (data.challenge) {
        window.alert("shouldn't be able to save a challenge!")
        return
    }
    delete data.subscriptionCount

    const newData = {
        ...toEdit,
        ...data,
    }

    setIsSaving(true)
    dispatch(saveOffering(newData))
        .then(result => {
            if (result.success === false && result.message) {
                throw result.message
            }
            setIsSaving(false)
            if (props.onHide) {
                props.onHide()
            }
        })
        .catch(err => {
            setIsSaving(false)
            setSaveError(err)
            window.alert(err)
        })

}




const { expires, type, price, frequency, discountType, firstPeriodPrice, freeTrialPeriodDays, subscriptionType } = watch()

// const buildPricingTextFrom = (price, frequency, discountType, firstPeriodPrice, freeTrialPeriodDays) => {
const buildPricingText = () => {

    if (!frequency) {
        return
    }

    if (discountType === 'firstPeriodDiscount') {
        return `First ${frequency.replace("ly", "")} for ${currencyFormatter.format(firstPeriodPrice)}, then ${currencyFormatter.format(price)} ${frequency} until canceled.`

    } else if (discountType === 'freeTrial') {
        return `First ${freeTrialPeriodDays ?? 0} days free, then ${currencyFormatter.format(price)} ${frequency} until canceled.`
    }

    return null
}

// switch on type
// fill viewModel placeholders with placeholders for each type
// need to swap out "count" for "frequency" on the subscription side.
return (
    <>
        <form onSubmit={handleSubmit(onSubmit)}>

            {oneTimeOffer && (<>

                {!toEdit && (
                    <FormGroup
                        select
                        options={offeringTypeOptions}
                        type="text"
                        name="type"
                        label="Type of offer"
                        sublabel=""
                        placeholder="Class pack or Subscription?"
                        error={errors.type}
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                        fullSize
                    />
                )}


                <FormGroup
                    select
                    options={newStudentOnlyOptions}
                    type="text"
                    name="newStudentOnly"
                    label="Who can purchase this special?"
                    sublabel=""
                    placeholder="Select one..."
                    error={errors.type}
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                    fullSize
                />

            </>)}

            {type && (<>

                <FormImageUploader
                    fullSize
                    imageUrl={toEdit?.imageUrl}
                    name="imageUrl"
                    label="Preview Image"
                    // defaultName={user.instructorProfile?.pageName}
                    filePath={`users/${partnerId}/files/`}
                    sublabel={"(optional) recommended aspect ratio 16:9"}
                    register={register}
                    onChange={(imageUrl) => setValue('imageUrl', imageUrl)}
                    imageUrl={getValues("imageUrl")}
                    error={errors.imageUrl}
                // getValues={getValues}
                // fileSelection={(file) => setValue('imageUrl', file)}
                />

                <FormGroup
                    type="text"
                    name="name"
                    label="Name"
                    placeholder={viewModel.placeholders.name}
                    register={register}
                    error={errors.name}
                    fullSize
                />

                <FormGroup
                    type="text"
                    texteditor
                    name="descriptionHTML"
                    label="Description"
                    placeholder={viewModel.placeholders.description}
                    register={register}
                    error={errors.description}
                    fullSize
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                />

                {type === 'subscription' && (
                    <FormGroup
                        select
                        options={subscriptionTypeOptions}
                        type="text"
                        name="subscriptionType"
                        label="Type of subscription"
                        sublabel=""
                        placeholder="Subscription"
                        error={errors.subscriptionType}
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                        fullSize
                    />
                )}

                {(type === 'subscription' && subscriptionType === 'limited') && (
                    <FormGroup
                        type="number"
                        name="subscriptionCount"
                        label="Number of classes"
                        placeholder="5"
                        register={register}
                        error={errors.subscriptionCount}
                        fullSize
                    />
                )}

                {type === 'pack' && (<>
                    <FormGroup
                        type="number"
                        name="count"
                        label="Number of classes"
                        placeholder="5"
                        register={register}
                        error={errors.count}
                        fullSize
                    />

                    <FormGroup
                        type="checkbox"
                        name="expires"
                        label="Expires"
                        placeholder="Check this box if you want this class pack to expire"
                        register={register}
                        error={errors.expires}
                        fullSize
                    />

                    {expires && (

                        <FormGroup
                            type="number"
                            name="expiresIn"
                            label="Expires in"
                            sublabel="How long will the student be able to use the class pack until it expires?"
                            placeholder="number of days"
                            register={register}
                            error={errors.expiresIn}
                            prepending={["days"]}
                            fullSize
                        />

                    )}
                </>)}
                {type === 'subscription' && (<>
                    <FormGroup
                        select
                        options={frequencyOptions}
                        type="text"
                        name="frequency"
                        label="Billing frequency"
                        sublabel="How often you want to charge your student"
                        placeholder="Select one"
                        error={errors.frequency}
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                        fullSize
                    />
                </>)}

                <FormGroup
                    type="number"
                    name="price"
                    label={"Price"}
                    placeholder={viewModel.placeholders.price}
                    register={register}
                    error={errors.price}
                    prepending={[currencySymbol]}
                    fullSize
                />

                {type === 'subscription' && (<>

                    {oneTimeOffer && (<>

                        <FormGroup
                            select
                            options={discountTypeOptions}
                            type="text"
                            name="discountType"
                            label="Type of discount"
                            sublabel="Would you like to offer a discount on this special offer?"
                            placeholder="Select one..."
                            error={errors.discountTypeOptions}
                            control={control}
                            setValue={setValue}
                            getValues={getValues}
                            fullSize
                        />

                        {discountType === 'firstPeriodDiscount' && (
                            <FormGroup
                                type="number"
                                name="firstPeriodPrice"
                                label={`First ${frequency?.replace('ly', '') ?? "period"} price`}
                                placeholder={viewModel.placeholders.price}
                                register={register}
                                error={errors.firstPeriodPrice}
                                prepending={[currencySymbol]}
                                fullSize
                            />
                        )}

                        {discountType === 'freeTrial' && (
                            <FormGroup
                                type="number"
                                name="freeTrialPeriodDays"
                                label={"Free trial length"}
                                placeholder={viewModel.placeholders.price}
                                register={register}
                                error={errors.freeTrialPeriodDays}
                                prepending={["days"]}
                                fullSize
                            />
                        )}

                        <div className="row mb-5">
                            <div className="col-md-3"></div>
                            <div className="col-md-9" style={{ color: "#28a745" }}>
                                {buildPricingText()}
                            </div>

                        </div>

                    </>)}
                </>)}

                <FormGroup
                    error={errors.locationTypes}
                    fullSize
                    select
                    isMulti={true}
                    options={locationTypeOptions}
                    type="text"
                    name="locationTypes"
                    label="Redeemable for"
                    placeholder="Live, On Demand, In Person"
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                />



                <FormGroup
                    type="checkbox"
                    name="private"
                    label="Private"
                    placeholder="Private offerings will not be listed on your pricing page. Only students with a direct link to purchase this offering will be able to find it."
                    register={register}
                    error={errors.private}
                    fullSize
                />

            </>)}
            <div className={"d-flex d-row py-3 " + (showAdvanced ? "d-none" : "")}>
                <Button
                    variant="link"
                    className="ml-auto"
                    onClick={() => {
                        setShowAdvanced(!showAdvanced)
                    }}>{showAdvanced ? "Hide Advanced" : "Show Advanced"}</Button>
            </div>

            <div className={showAdvanced ? "" : "d-none"}>
                <FormGroup
                    error={errors.applies_to_services}
                    fullSize
                    select
                    isMulti={true}
                    options={serviceOptions}
                    type="text"
                    name="applies_to_services"
                    label="Applies to specific class templates"
                    placeholder="Optional"
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                />
                <FormGroup
                    error={errors.applies_to_categories}
                    fullSize
                    select
                    isMulti={true}
                    options={categoryOptions}
                    type="text"
                    name="applies_to_categories"
                    label="Applies to specific on-demand categories"
                    placeholder="Optional"
                    control={control}
                    setValue={setValue}
                    getValues={getValues}
                />

                {type === 'subscription' && (
                    <FormGroup
                        error={errors.challenges}
                        fullSize
                        select
                        isMulti={true}
                        options={challengeOptions}
                        type="text"
                        name="challenges"
                        label="Includes Communities"
                        placeholder="Optional"
                        control={control}
                        setValue={setValue}
                        getValues={getValues}
                    />
                )}

            </div>

            <Modal.Footer>
                <Button type="submit" variant="primary" disabled={isSaving}>
                    <span>Save changes</span>
                    {isSaving && (
                        <Spinner
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden={true}
                            className="ml-2"
                        >
                            <span className="sr-only">Sending...</span>
                        </Spinner>

                    )}
                </Button>
            </Modal.Footer>
            {/* <div className="row">
                
            </div> */}

        </form>
        <DevTool control={control} />
    </>

)
}

function OfferingEditorModal(props) {

    const { show, onHide, toEdit } = props
    var { pack, subscription, challenge, oneTimeOffer } = props

    if (toEdit?.type) {
        // console.log(`type: ${toEdit.type}`)
        switch (toEdit.type) {
            case "pack":
                pack = true
                subscription = false
                challenge = false
                break
            case "subscription":
                pack = false
                subscription = true
                challenge = false
                break
            case "challenge":
                pack = false
                subscription = false
                challenge = true
                break
            default:
                break
        }
    }
    var viewModel = {
        title: "",
        description: ""
    }

    if (pack) {
        viewModel.title = toEdit ? "Edit package" : "Add package"
        viewModel.description = "A package is a group of classes that is typically discounted when a customer purchases multiple quantities. Packages do not expire and can be used on any live class."
    } else if (subscription) {
        viewModel.title = toEdit ? "Edit subscription" : "Add subscription"
        viewModel.description = "A subscription is re-occuring payment that your clients pay you to access an unlimited amount of your services."
    } else if (challenge) {
        viewModel.title = toEdit ? "Edit challenge" : "Add challenge"
        viewModel.description = "A challenge is a one time payment consisting of a pack of services. For example: Rachel Lea offers a 30-day challenge for 20 which includes 3 workouts per week, 2 private consultations, and a nutrition plan PDF. She uses Sutra to accept payments and manage her student community."
    } else if (oneTimeOffer) {
        viewModel.title = toEdit ? "Edit intro offer" : "Add intro offer"
        viewModel.description = "An intro offer is a package or subscription that can only be purchased one time. This is great for offering new students a discount to your subscription or their first class pack at a discounted price."
    }

    return (
        <Modal
            centered
            // className={"modal-container custom-map-modal"}
            size="lg"
            // {...props}
            show={show}
            onHide={onHide}
        >
            <Modal.Header closeButton>
                {viewModel.title}
            </Modal.Header>
            <Modal.Body>
                {/* <p>A package is a group of classes that is typically discounted when a customer purchases multiple quantities. Packages do not expire and can be used on any live class.</p> */}
                <p className="mb-5"><big>{viewModel.description}</big></p>
                <PackageEditor
                    {...props}
                    toEdit={toEdit}
                />
            </Modal.Body>


        </Modal>
    )
}

function NewOfferingButton(props) {

    const [newPackOpen, setNewPackOpen] = React.useState(false)
    const [newSubOpen, setNewSubOpen] = React.useState(false)
    const [newChallengeOpen, setNewChallengeOpen] = React.useState(false)
    const [newOneTimeOfferOpen, setNewOneTimeOfferOpen] = React.useState(false)
    return (
        <div>
            <OfferingEditorModal
                {...props}
                pack
                show={newPackOpen}
                onHide={() => setNewPackOpen(false)}
            />
            <OfferingEditorModal
                {...props}
                subscription
                show={newSubOpen}
                onHide={() => setNewSubOpen(false)}
            />

            <OfferingEditorModal
                {...props}
                challenge
                show={newChallengeOpen}
                onHide={() => setNewChallengeOpen(false)}
            />

            <OfferingEditorModal
                {...props}
                oneTimeOffer
                show={newOneTimeOfferOpen}
                onHide={() => setNewOneTimeOfferOpen(false)}
            />

            <DropdownButton onClick={() => analytics.track("Tried to add package or sub")} id="dropdown-basic-button" title="Add New ">
                {/* <Dropdown.Item onClick={() => console.log("wahoo")}>Disabled for maintenance</Dropdown.Item> */}
                <Dropdown.Item onClick={() => setNewPackOpen(true)}>Class Pack</Dropdown.Item>
                <Dropdown.Item onClick={() => setNewSubOpen(true)}>Subscription</Dropdown.Item>
                <Dropdown.Item onClick={() => setNewOneTimeOfferOpen(true)}>Intro Offer</Dropdown.Item>
                {/* <Dropdown.Item onClick={() => setNewChallengeOpen(true)}>Challenge</Dropdown.Item> */}
            </DropdownButton>
        </div>
    );
}

export default NewOfferingButton

function EditOfferingButton(props) {

    const [open, setOpen] = React.useState(false)
    return (
        <div>

            <OfferingEditorModal
                {...props} // includes toEdit
                show={open}
                onHide={() => setOpen(false)}
            />
            <IconButton onClick={() => {
                if (!props.toEdit) {
                    window.alert("Unable to edit class")
                }
                setOpen(true)
            }}>
                <EditIcon />
            </IconButton>
        </div>
    );
}

export { EditOfferingButton }

function DeleteOfferingButton(props) {

    const [alert, setAlert] = React.useState(false)
    const { toDelete } = props

    const dispatch = useDispatch()

    function handleDelete() {

        console.log("Deleting offer")
        dispatch(deleteOffering(toDelete))
            .then(res => {
                setAlert(false)
            })
    }

    function confirmDelete() {

        setAlert(
            <SweetAlert
                showCancel
                confirmBtnText="Remove"
                confirmBtnBsStyle="danger"
                title="Are you sure you would like to remove?"
                onConfirm={() => handleDelete()}
                onCancel={() => setAlert(null)}
                focusCancelBtn
            >
                If you do, you can no longer sell this option. Previous students who have purchased it will still be able to redeem these services.
            </SweetAlert>
        )
    }

    return (
        <div>
            {alert}
            <IconButton style={{ color: "#ff4136" }} onClick={() => confirmDelete()}>
                <DeleteOutlineIcon />
            </IconButton>
        </div>
    );
}

export { DeleteOfferingButton }